import { render } from "./EnrollmentView.vue?vue&type=template&id=0cb464f6"
import script from "./EnrollmentView.vue?vue&type=script&lang=js"
export * from "./EnrollmentView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__